module.exports = __webpack_public_path__ + "static/media/green-line_s-home_trending.dea4c20f.svg";